"use strict";

/* FAQ ACCORDION */
document.addEventListener("DOMContentLoaded", function() {
  const faqItems = document.querySelectorAll(".faq-item");
  faqItems.forEach(item => {
    const question = item.querySelector(".faq-question");
    if (!question) return;
    question.addEventListener("click", () => {
      const isActive = item.classList.contains("active");
      faqItems.forEach(otherItem => {
        otherItem.classList.remove("active");
        const otherQuestion = otherItem.querySelector(".faq-question");
        if (otherQuestion) otherQuestion.setAttribute("aria-expanded", "false");
      });
      if (!isActive) {
        item.classList.add("active");
        question.setAttribute("aria-expanded", "true");
      }
    });
  });
});

/* UGC VIDEO CARDS */
function labnolIframe(card) {
  var videoId = card.dataset.videoId;
  if (!videoId) return;

  var wrapper = document.createElement("div");
  wrapper.style.cssText = "position: relative; width: 100%; padding-bottom: 56.25%; height: 0; overflow: hidden;";

  var iframe = document.createElement("iframe");
  iframe.setAttribute("src", "https://www.youtube.com/embed/" + videoId + "?autoplay=1&rel=0");
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute("allowfullscreen", "1");
  iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
  iframe.style.cssText = "position: absolute; top: 0; left: 0; width: 100%; height: 100%;";

  wrapper.appendChild(iframe);
  card.innerHTML = "";
  card.appendChild(wrapper);
}

function initUGCVideos() {
  document.querySelectorAll(".ugc-card").forEach(function(card) {
    card.addEventListener("click", function() {
      labnolIframe(card);
    });
    card.addEventListener("keydown", function(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        labnolIframe(card);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initUGCVideos);

/* KIT PINS */
(function() {
  const pins = document.querySelectorAll('.pin');
  const items = document.querySelectorAll('.kititem');

  function activate(i) {
    pins.forEach(p => p.classList.remove('is-on'));
    items.forEach(it => it.classList.remove('is-on'));
    if (pins[i]) pins[i].classList.add('is-on');
    if (items[i]) items[i].classList.add('is-on');
  }

  pins.forEach((p, i) => p.addEventListener('click', () => activate(i)));
  items.forEach((it, i) => {
    it.addEventListener('click', () => activate(i));
    it.addEventListener('mouseenter', () => activate(i));
  });
})();

/* PRESS QUOTES ROTATOR */
(function() {
  const items = document.querySelectorAll('.press-quote__item');
  const dots = document.querySelectorAll('.press-quote__dots button');
  if (!items.length) return;
  let idx = 0;
  let interval;

  function go(i) {
    idx = i;
    items.forEach((el, n) => el.classList.toggle('is-on', n === i));
    dots.forEach((el, n) => el.classList.toggle('is-on', n === i));
  }

  function next() {
    go((idx + 1) % items.length);
  }

  function start() {
    interval = setInterval(next, 5000);
  }

  function stop() {
    clearInterval(interval);
  }

  dots.forEach((d, i) => d.addEventListener('click', () => {
    stop();
    go(i);
    start();
  }));

  start();
})();

/* SPEC ACCORDIONS */
(function() {
  const items = document.querySelectorAll('.spec details');
  items.forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        items.forEach(other => {
          if (other !== item && other.open) other.open = false;
        });
      }
    });
  });
})();

/* JUMP NAV SCROLLSPY */
(function() {
  const links = document.querySelectorAll('.jumpnav a[data-anchor]');
  const map = {};
  links.forEach(a => {
    const id = a.dataset.anchor;
    const el = document.getElementById(id);
    if (el) map[id] = { link: a, el };
  });

  function onScroll() {
    const y = window.scrollY + 180;
    let current = null;
    Object.entries(map).forEach(([id, obj]) => {
      if (y >= obj.el.offsetTop) current = id;
    });
    links.forEach(a => a.classList.remove('is-on'));
    if (current && map[current]) map[current].link.classList.add('is-on');
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* STICKY MINI-CART BAR */
(function() {
  const buybox = document.getElementById('buybox');
  const minibar = document.getElementById('minibar');
  if (!buybox || !minibar) return;

  function check() {
    const r = buybox.getBoundingClientRect();
    if (r.bottom < 0) minibar.classList.add('is-on');
    else minibar.classList.remove('is-on');
  }

  window.addEventListener('scroll', check, { passive: true });
  check();
})();

/* SMOOTH ANCHOR SCROLL */
(function() {
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          const top = el.getBoundingClientRect().top + window.pageYOffset - 110;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    });
  });
})();

/* ADD TO CART — scAddToCart() */
function scAddToCart(btn) {
  const variantId = btn.dataset.variantId;

  if (!variantId || variantId === '') {
    console.error('scAddToCart: no variant ID');
    alert('Could not add to cart — no variant found.');
    return;
  }

  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding...';

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: parseInt(variantId),
      quantity: 1
    })
  })
  .then(function(response) {
    if (!response.ok) {
      return response.json().then(function(err) {
        throw new Error(err.description || 'Add to cart failed');
      });
    }
    return response.json();
  })
  .then(function(item) {
    console.log('Added to cart:', item);
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function(bubble) {
          const hidden = bubble.querySelector('[aria-hidden]');
          const visual = bubble.querySelector('.visually-hidden');
          if (hidden) hidden.textContent = cart.item_count;
          if (visual) visual.textContent = cart.item_count + ' items';
        });
        btn.textContent = '✓ Added!';
        btn.style.background = '#1F6764';
        setTimeout(function() {
          window.location.href = '/cart';
        }, 800);
      });
  })
  .catch(function(error) {
    console.error('Cart error:', error);
    btn.textContent = error.message || 'Error — try again';
    btn.style.background = '#c0392b';
    setTimeout(function() {
      btn.textContent = original;
      btn.style.background = '';
      btn.disabled = false;
    }, 2500);
  });
}

/* PRODUCT-LINE QUIZ */
(function() {
  const quiz = document.getElementById('quiz');
  const result = document.getElementById('quizResult');
  const resultName = document.getElementById('quizResultName');
  const resultBody = document.getElementById('quizResultBody');
  const resultCta = document.getElementById('quizResultCta');
  if (!quiz || !result) return;

  const SOLACE_RESULT = {
    name: 'SayCheese™ <em>SOLACE</em> Sensitive',
    body: 'Because sensitivity is your biggest concern, start with the comfort-first product line. PAP/PAP+ peroxide-free route, designed for sensitivity-prone smiles seeking a Natural White finish.',
    cta: 'Choose SOLACE Sensitive →',
    href: '/products/premium-whitening-kit-sensitive-pap'
  };
  const SOLACE_NATURAL = {
    name: 'SayCheese™ <em>SOLACE</em> Sensitive',
    body: 'Because you are looking for a natural-looking white finish, SOLACE is your best fit. Comfort-first whitening with the PAP/PAP+ peroxide-free route — even if you tolerate peroxide.',
    cta: 'Choose SOLACE Sensitive →',
    href: '/products/premium-whitening-kit-sensitive-pap'
  };
  const ASCEND_EVENT = {
    name: 'SayCheese™ <em>ASCEND</em> Radiant',
    body: 'Because you tolerate peroxide and you are preparing for a visible moment, ASCEND fits the brief. Controlled-peroxide whitening for non-sensitive, stain-prone smiles seeking a Radiant White finish.',
    cta: 'Choose ASCEND Radiant →',
    href: '/products/premium-whitening-kit-non-sensitive'
  };
  const ASCEND_RADIANT = {
    name: 'SayCheese™ <em>ASCEND</em> Radiant',
    body: 'Because you tolerate peroxide well and want a more radiant finish, ASCEND is the better fit. Use as directed; if sensitivity ever becomes your concern, SOLACE is the comfort-first alternative.',
    cta: 'Choose ASCEND Radiant →',
    href: '/products/premium-whitening-kit-non-sensitive'
  };

  function render() {
    const sensitivity = quiz.querySelector('input[name="sensitivity"]:checked').value;
    const finish = quiz.querySelector('input[name="finish"]:checked').value;
    const event = quiz.querySelector('input[name="event"]:checked').value;

    let pick;
    if (sensitivity === 'yes') {
      pick = SOLACE_RESULT;
    } else if (finish === 'natural') {
      pick = SOLACE_NATURAL;
    } else if (event === 'yes') {
      pick = ASCEND_EVENT;
    } else {
      pick = ASCEND_RADIANT;
    }

    resultName.innerHTML = pick.name;
    resultBody.textContent = pick.body;
    resultCta.textContent = pick.cta;
    resultCta.setAttribute('href', pick.href);
  }

  quiz.querySelectorAll('input[type="radio"]').forEach(input => {
    input.addEventListener('change', render);
  });
  render();
})();

(function() {

  function toggleBundleDiscount() {
    const checked  = document.querySelector('input[name="selling_plan"]:checked');
    const bundle   = document.querySelector('.ab-volume-discount-container');
    if (!bundle) return;

    // Subscription = non-empty selling_plan value → hide bundle
    // One-time     = empty value or nothing checked  → show bundle
    const isSubscription = checked && checked.value !== '';
    bundle.style.display = isSubscription ? 'none' : '';
  }

  // Event delegation — fires for any selling_plan radio, even ones added later
  document.addEventListener('change', function(e) {
    if (e.target && e.target.name === 'selling_plan') {
      toggleBundleDiscount();
    }
  });

  // MutationObserver catches Appstle's async first render
  // Once the widget appears, run the initial state check
  var observer = new MutationObserver(function() {
    var widget = document.querySelector('input[name="selling_plan"]');
    if (widget) {
      toggleBundleDiscount();
      observer.disconnect(); // event delegation handles everything after this
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    toggleBundleDiscount(); // in case Appstle loaded synchronously
    observer.observe(document.body, { childList: true, subtree: true });
  });

})();